<template>
  <div v-if="parsedDescription" class="tw:flexrow-0 tw:pointer-events-auto">
    <div
      v-if="!collapsed"
      class="tw:border tw:shadow-md tw:-mr-1 tw:border-gray-200 tw:bg-white/90 tw:text-gray-700 tw:text-xs tw:flexcenter tw:px-2 tw:rounded-l-base"
    >
      <span v-for="(text, idx) in parsedDescription" :key="idx" class="tw:whitespace-break-spaces">
        <a v-if="text.url" :href="text.url" target="_blank">{{ text.text }}</a>
        <template v-else>{{ text }}</template>
      </span>
    </div>
    <base-button type="map-control" icon="mdi-information-outline" size="sm" @click="collapsed = !collapsed" />
  </div>
</template>

<script>
import { parseMarkdownUrlText } from '@/assets/js/utility';
import { get } from 'vuex-pathify';

export default {
  name: 'BasemapAttribution',
  props: {
    basemap: {
      type: [Number, null],
    },
  },
  data: () => ({
    collapsed: false,
  }),
  watch: {
    basemap() {
      this.collapsed = false;
      this.$emit('onMap', map => this.assignCollapseListener(map));
    },
  },
  computed: {
    basemapLayers: get('layers/basemapLayers'),
    basemapDescription() {
      return this.basemapLayers[this.basemap]?.description;
    },
    parsedDescription() {
      return this.basemapDescription ? parseMarkdownUrlText(this.basemapDescription) : null;
    },
  },
  methods: {
    assignCollapseListener(mapContext) {
      mapContext.getView().once('change:center', () => (this.collapsed = true));
    },
    onMapInit() {
      this.$emit('onMap', map => map.once('rendercomplete', () => this.assignCollapseListener(map)));
    },
  },
  mounted() {
    this.onMapInit();
  },
};
</script>
